<template>
  <div class="d-flex main-wrapper">
    <div class="container d-flex py-5 main-container">
      <div class="my-auto w-100 main-area nofound-area text-center">
        <span class="error-logo" style="margin-bottom: 50px; margin-right: 15px">
          <img src="@/assets/images/wtiogomark_ra.png" alt="logo" class="img-fluid" height="auto" width="20%">
        </span>
        このページは現在ご利用いただけません。
        <span class="error-image">
          <img src="@/assets/images/errorimage.1.png" alt="logo" class="img-fluid">
        </span>

        <h1>Oops!</h1>
          <p style="color:black">Page Not Found</p>
        <!-- <h1>Oops!<br/>It’s a dead end...</h1> -->
        <!-- <p>The page you are looking for<br/>
          might have been moved, renamed,<br/>
          or might never existed.</p> -->
        <div class="btn-toolbar justify-content-center" role="toolbar"
             aria-label="Toolbar with button groups">
          <router-link to="/applicant" class="btn btn-primary">BACK TO HOME</router-link>
        </div>
      </div><!-- ends main-area -->
    </div>
  </div>
</template>

<script>
export default {
  name: '404',
};
</script>
